import { render, staticRenderFns } from "./adminTab.vue?vue&type=template&id=3d6c9b6c"
import script from "./adminTab.vue?vue&type=script&lang=js"
export * from "./adminTab.vue?vue&type=script&lang=js"
import style0 from "./adminTab.vue?vue&type=style&index=0&id=3d6c9b6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports